module.exports = __webpack_public_path__ + "static/media/armenia-large.3959e801.jpg";